export default {
    dashboard: 'ภาพรวมข้อมูล',
    inquiryAttendance: 'คำร้องและการลงเวลา',
    devicesManagement: 'จัดการตำแหน่งแสกนใบหน้า',
    employeeManagement: 'บริหารจัดการพนักงาน',
    timeTableSetting: 'ตั้งค่าเวลาทำงาน',
    visitor: 'ผู้เยี่ยมเยือน',
    blackList: 'บัญชีดำ',
    nvrPunchLog: 'บันทึก NVR',
    systemActivityLog: 'บันทึกการใช้งาน',
    logOut: 'ลงชื่อออก',
    poweredBy: 'พัฒนาโดย โอคอนเทค'
}
